'use client'

import React from 'react'
import { Breadcrumbs } from '../../_components/Breadcrumps'
import AnimatedSection from '@/components/AnimatedSection'
import Main from './_blocks/Main'
import OurApproach from './_blocks/OurApproach'
import Services from './_blocks/Services'
import WorkStages from './_blocks/WorkStages'
import WhyChooseUs from '../complex-solutions/_blocks/WhyChooseUs'
import CtaBannerCentered from '../_blocks/CtaBannerCentered'
import Clients from '../_blocks/Clients'
import Industries from '../_blocks/Industries'
import Portfolio from '@/app/portfolio/[portfolio]/_blocks/Portfolio'
import Contact from '@/app/_blocks/Main_redesign/Contact'
import styles from './styles.module.css'

export default function IntegrationsPage() {
	return (
		<>
			<Breadcrumbs className={styles.breadcrumbs} />
			<main className={styles.main}>
				<Main />
				<OurApproach />
				<Services />
				<AnimatedSection animation="slideUp">
					<div className={styles.workStagesBlock}>
						<WorkStages />
					</div>
				</AnimatedSection>
				<AnimatedSection animation="slideUp">
					<div className={styles.whyChooseUsBlock}>
						<WhyChooseUs />
					</div>
				</AnimatedSection>
				<AnimatedSection animation="slideUp">
					<div className={styles.clientsBlock}>
						<Clients />
					</div>
				</AnimatedSection>
				<AnimatedSection animation="slideUp">
					<div className={styles.ctaBannerBlock}>
						<CtaBannerCentered />
					</div>
				</AnimatedSection>
				<AnimatedSection animation="slideUp">
					<div className={styles.industriesBlock}>
						<Industries />
					</div>
				</AnimatedSection>
				<AnimatedSection animation="slideUp">
					<div className={styles.portfolioBlock}>
						<Portfolio />
					</div>
				</AnimatedSection>
				<AnimatedSection animation="slideUp">
					<div className={styles.contactBlock}>
						<Contact />
					</div>
				</AnimatedSection>
			</main>
		</>
	)
}